import axiosIns from '@/libs/axios'
import uploadWithProgress from '@/store/helpers/upload'
import toErrorResult from '@/store/helpers/errorResult'

const ROOT_URL = '/Admin/data/project_media_gallery'
export default {
  namespaced: true,
  state: {
    loading: false,
    uploading: false,
    uploadProgress: {
      loaded: 0,
      total: 0,
    },
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      title: null,
      file_name: null,
      file_type: null,
      file_size: null,
      media_type: null,
      item_id: null,
      id_users: null,
      upload_file: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    uploading(state) {
      return state.uploading
    },
    uploadProgress(state) {
      return state.uploadProgress
    },
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_UPLOADING(state, data) {
      state.uploading = data
    },
    SET_UPLOAD_PROGRESS(state, data) {
      state.uploadProgress = data
    },
    UPDATE_ITEM_TITLE(state, { id, title }) {
      const item = state.dataList.find(row => String(row.id) === String(id))
      if (item) {
        item.title = title
      }
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        title: null,
        file_name: null,
        file_type: null,
        file_size: null,
        media_type: null,
        item_id: null,
        id_users: null,
        upload_file: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const formData = new FormData()
      formData.append('title', postData.title)
      formData.append('file_name', postData.file_name)
      formData.append('file_type', postData.file_type)
      formData.append('file_size', postData.file_size)
      formData.append('media_type', postData.media_type)
      formData.append('item_id', postData.item_id)
      formData.append('upload_file', postData.upload_file)
      return uploadWithProgress(commit, `${ROOT_URL}/saveData`, formData)
    },
    // Yalnız başlığı günceller; listedeki kaydı yerinde değiştirir (açık pencere kapanmasın diye liste yeniden çekilmez)
    updateTitle({ commit }, { id, title }) {
      return axiosIns
        .post(`${ROOT_URL}/updateTitle`, { id, title })
        .then(response => {
          if (response.data.status) {
            commit('UPDATE_ITEM_TITLE', { id, title })
          }
          return response.data
        })
        .catch(error => toErrorResult(error))
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
